import { jsx, jsxs } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { AnimatePresence } from 'framer-motion';
import { forwardRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm.js';
import { CanvasOffscreenProvider } from '../CanvasOffscreen/canvas-offscreen.js';

const Root = /*#__PURE__*/forwardRef(function Root(_ref, ref) {
  let {
    opened,
    embedded,
    customIntro,
    shouldShowTrigger,
    mode
  } = _ref;
  const {
    Main,
    Font,
    Trigger
  } = useLlm(state => state.components);
  const classNames = getClassNames('llm', 'llm__root', 'llm__reset', {
    '-open': opened,
    '-embedded': embedded,
    '-custom-intro': customIntro,
    ['-' + mode]: true
  });
  return jsx("section", {
    ref: ref,
    className: classNames,
    "data-opened": opened,
    "data-embedded": embedded,
    "data-custom-intro": customIntro,
    "data-mode": mode,
    children: jsxs(CanvasOffscreenProvider, {
      children: [jsx(Font, {}), jsx(AnimatePresence, {
        mode: "wait",
        initial: false,
        children: opened && jsx(Main, {}, "main")
      }), jsx(AnimatePresence, {
        mode: "wait",
        initial: false,
        children: shouldShowTrigger && jsx(Trigger, {}, "trigger")
      })]
    })
  });
});

export { Root };
//# sourceMappingURL=root.js.map
